import React from "react";
import "../css/Contact.css";

const Contact = () => {
  return (
    <div className="contact">
      <div className="map__container">
        <h4>Address</h4>
        <p>25, Gloucester Road, Bishopston, BS7 8AA, Bristol</p>
        <div className="map__iframe-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2485.3039287846477!2d-2.5955239229621334!3d51.47093531336601!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48718e0bd89f0239%3A0x750d425a5b2c128c!2sGloucester%20Road%20Pharmacy!5e0!3m2!1sen!2suk!4v1732661987229!5m2!1sen!2suk"
            style={{
              border: 0,
            }}
            loading="lazy"
          ></iframe>
        </div>
        <p><small>(Tap on the map to get directions to our pharmacy)</small></p>
        <br />
        <h4>Telephone number</h4>
        <p><a href="tel:01179491143">0117 949 1143</a> <small>(Click/Tap to give us a ring)</small></p>
        <br /> 
        <h4>Opening hours</h4>
        <p>Mon to Fri : 9am - 6pm</p>
        <p>Sat : 9am - 5.30pm</p>
        <p>Sun : Closed</p>
      </div>
    </div>
  );
};

export default Contact;
